import { ROLE } from "./roles/roles";

export const checkRoleAccess = (
  accessRoles,
  userRoleArray,
  isCreator = false,
  roles = [],
) => {
  if (isCreator) {
    return true;
  }
  const isAdmin = roles.some((el) => el === ROLE.ADMIN);
  if (isAdmin) {
    return true;
  }
  return userRoleArray.some((userRole) => {
    return accessRoles.includes(userRole);
  });
};
